
import { Badge } from "@/components/ui/badge";

interface TagFiltersProps {
  title: string;
  tags: string[];
  selectedFilters: string[];
  onToggleFilter: (filter: string) => void;
}

export const TagFilters = ({ title, tags, selectedFilters, onToggleFilter }: TagFiltersProps) => {
  if (!tags.length) return null;

  return (
    <div>
      <h3 className="text-sm font-medium mb-2">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <Badge 
            key={tag} 
            variant={selectedFilters.includes(tag) ? "default" : "outline"}
            className="cursor-pointer transition-colors duration-150"
            onClick={() => onToggleFilter(tag)}
          >
            {tag}
          </Badge>
        ))}
      </div>
    </div>
  );
};
